import React, { Component } from 'react';
import { Row, Col, Progress, Card, ButtonToolbar, Alert, CardHeader, CardTitle, FormGroup, Label, Form, Input, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Button, ButtonDropdown, Table, Badge, Pagination, PaginationItem, PaginationLink, DropdownMenu, DropdownToggle, ButtonGroup, Dropdown, DropdownItem, FormText, InputGroup, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { ajaxWrapperPost, ajaxWrapperGet, ajaxWrapperDelete } from '../../../utils/deviceAPI';
import classnames from 'classnames';
import LoadingIndicator from '../../../utils/LoadingIndicator';
import UsersNotificationSystem from '../../Admin/Users/UsersNotificationSystem';
import Select from 'react-select';
import NotificationHOC from "../../../components/Notifications/NotificationHOC"
import 'react-select/dist/react-select.min.css';
import DeveloperOverviewRender from './DeveloperOverviewRender/DeveloperOverviewRender';
import { get } from 'lodash';
let dataTypeInt = require('./DeveloperOverviewRender/Components/Data/DataTypesInt.json');
let dataTypeBool = require('./DeveloperOverviewRender/Components/Data/DataTypesBool.json');
let generatorData = require('./DeveloperOverviewRender/Components/Data/Generator.json');
let atsData = require('./DeveloperOverviewRender/Components/Data/Ats.json');
let listData = require('./DeveloperOverviewRender/Components/Data/List.json');
let controlToggle = require('./DeveloperOverviewRender/Components/Data/controlToggle.json');

const tagBits = [
    { id: "0", text: ".0" },
    { id: "1", text: ".1" },
    { id: "2", text: ".2" },
    { id: "3", text: ".3" },
    { id: "4", text: ".4" },
    { id: "5", text: ".5" },
    { id: "6", text: ".6" },
    { id: "7", text: ".7" },
    { id: "8", text: ".8" },
    { id: "9", text: ".9" },
    { id: "10", text: ".10" },
    { id: "11", text: ".11" },
    { id: "12", text: ".12" },
    { id: "13", text: ".13" },
    { id: "14", text: ".14" },
    { id: "15", text: ".15" },
    { id: "99", text: "noBit" }
];
class Developer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            dropdownOpen: new Array(19).fill(false),
            selectedRow: -1,
            overViewData: [
                {
                    id: 0,
                    rowData: []
                }
            ],
            developer: true,
            componentInEditMode: false
        };
        this.toggleDeveloperMode = this.toggleDeveloperMode.bind(this);
        this.componentIsBeingEdited = this.componentIsBeingEdited.bind(this);
    }
    componentDidMount() {
        this.setData();
    }
    componentWillReceiveProps(nextProps) {
        const dev = this.props.match.params.dev.replace('device_', '');
        const newDev = nextProps.match.params.dev.replace('device_', '');
        if (dev !== newDev) {
            this.setData(newDev);
        }
    }

    componentWillUnmount() {
    }

    toggleDeveloperMode() {
        if (this.state.developer) {
            console.log('settinginterval');
            this.tick();
            this.timerID = setInterval(
                () => this.tick(),
                5000
            );
        }

        else {
            console.log('clear interval');
            clearInterval(this.timerID);
            this.setState({
                developer: true
            });
        }
    }
    toggle(i) {
        const newArray = this.state.dropdownOpen.map((element, index) => { return (index === i ? !element : false); });
        this.setState({
            dropdownOpen: newArray,
        });
    }
    tick(device = this.props.match.params.dev.replace('device_', '')) {
        ajaxWrapperGet('/dev/developer', device).then((data) => {
            this.setState({
                data,
                developer: false,
                selectedRow: -1
            });

        });
    }
    setData(device = this.props.match.params.dev.replace('device_', '')) {
        ajaxWrapperGet('/dev/developer', device).then((data) => {
            console.log(data);
            ajaxWrapperGet('/dev/site/getControl', device).then((overViewData) => {
                this.setState({
                    overViewData: overViewData.data,
                    data,
                    loading: false
                });
            });

        });
    }

    dragTransfer = (rowDataItem, toRowNumber, fromRowNumber) => {
        //console.log('------');
        //console.log('rowDataItem: ', rowDataItem);
        //console.log('toRowNumber: ', toRowNumber);
        //console.log('fromRowNumber: ', fromRowNumber);
        let overviewData = this.state.overViewData;
        let grabItemData;

        for (let row = 0; row < overviewData.length; row++) {
            if (overviewData[row].id === parseInt(fromRowNumber)) {
                for (let rowItem = 0; rowItem < overviewData[row].rowData.length; rowItem++) {
                    if (overviewData[row].rowData[rowItem].order === parseInt(rowDataItem)) {
                        grabItemData = JSON.parse(JSON.stringify(overviewData[row].rowData[rowItem]));
                        overviewData[row].rowData.splice(rowItem, 1);
                    }
                }
            }
        }


        //placing new data in array
        for (let row = 0; row < overviewData.length; row++) {
            if (overviewData[row].id === parseInt(toRowNumber)) {
                overviewData[row].rowData.push(grabItemData)
            }
        }

        this.setState({
            overviewData: this.cleanUpArrayNumbering(overviewData)
        })

    };

    expandChildSize = (rowId, itemId) => {
        let overviewData = this.state.overViewData;
        overviewData[rowId]['rowData'][itemId]['size'] = {
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
        };
        this.setState({
            overviewData
        })
    };

    cleanUpArrayNumbering(overviewData) {
        //cleaning up array
        for (let row = 0; row < overviewData.length; row++) {
            overviewData[row].id = row;
            for (let rowItem = 0; rowItem < overviewData[row].rowData.length; rowItem++) {
                overviewData[row].rowData[rowItem].order = rowItem;
            }
        }
        return overviewData;
    }
    // add functions
    addNew(type) {
        let overviewData = this.state.overViewData;
        let selectedRow = this.state.selectedRow === -1 ? 0 : this.state.selectedRow;

        if (type === 'row') overviewData.push({
            id: 99,
            rowData: []
        });
        else if (overviewData[selectedRow] === undefined) {
            this.refs.notification.notify('You must add a row before adding a component', 'error');
        }
        else {
            switch (type) {
                case 'row':
                    break;
                case 'generator':
                    overviewData[selectedRow].rowData.push(JSON.parse(JSON.stringify(generatorData)));
                    break;
                case 'ats':
                    overviewData[selectedRow].rowData.push(JSON.parse(JSON.stringify(atsData)));
                    break;
                case 'list':
                    overviewData[selectedRow].rowData.push(JSON.parse(JSON.stringify(listData)));
                    break;
                case 'controlToggle':
                    overviewData[selectedRow].rowData.push(JSON.parse(JSON.stringify(controlToggle)));
                    break;
            }
        }

        this.setState({
            overviewData: this.cleanUpArrayNumbering(overviewData)
        })
    }

    addNewDataToChild(schema, row, component, dataType = 'int') {
        //console.log(schema, row, component);
        let overviewData = this.state.overViewData;
        let splitValue = schema.split('.');
        switch (splitValue.length) {
            case 2:
                overviewData[row]['rowData'][component]['data'][splitValue[0]][splitValue[1]].push(JSON.parse(JSON.stringify(dataType === 'bool' ? dataTypeBool : dataTypeInt)));
                break;
            case 4:
                break;
        }
        this.setState({
            overviewData: this.cleanUpArrayNumbering(overviewData)
        })
    }

    deleteItem = (type, rowId = -1, itemId = -1) => {
        let overviewData = this.state.overViewData;
        switch (type) {
            case 'row':
                overviewData.splice(rowId, 1);
                break;
            case 'component':
                overviewData[rowId].rowData.splice(itemId, 1);
                break;
        }
        this.setState({
            overviewData: this.cleanUpArrayNumbering(overviewData)
        })
    };


    saveConfiguration = () => {
        let postData = {
            dev: this.props.match.params.dev.replace('device_', ''),
            data: this.state.overViewData
        };
        ajaxWrapperPost(`/dev/site/saveControl`, postData).then((data) => {
            if (data.error === false) {
                this.refs.notification.notify(data.message, 'success');
                this.setData();
            }
            else if (data.error === true) {
                this.refs.notification.notify(data.message, 'error');
            }
        });

    };

    writeControl = (tag, bit, state) => {
        let postData = {
            tag: tag,
            bit: bit,
            state: state
        };
        ajaxWrapperPost(`/api/controlDevice?dev=${this.props.match.params.dev.replace('device_', '')}`, postData).then((data) => {
            if (data.error === false) {
                this.refs.notification.notify(data.message, 'success');
                this.setData();
            }
            else if (data.error === true) {
                this.refs.notification.notify(data.message, 'error');
            }
        });

    };

    saveTextValueChanges = (row, component, textFieldName, textFieldValue) => {
        console.log(row, component, textFieldName, textFieldValue);
        let overviewData = this.state.overViewData;
        if (textFieldName.includes('.')) {
            let splitValue = textFieldName.split('.');
            switch (splitValue.length) {
                case 2:
                    overviewData[row]['rowData'][component]['data'][splitValue[0]][splitValue[1]] = textFieldValue;
                    break;
                case 3:
                    overviewData[row]['rowData'][component]['data'][splitValue[0]][splitValue[1]][splitValue[2]] = textFieldValue;
                    break;
                case 4:
                    overviewData[row]['rowData'][component]['data'][splitValue[0]][splitValue[1]][splitValue[2]][splitValue[3]] = textFieldValue;
                    break;
                case 5:
                    overviewData[row]['rowData'][component]['data'][splitValue[0]][splitValue[1]][splitValue[2]][splitValue[3]][splitValue[4]] = textFieldValue;
                    break;

            }
        }
        else {
            overviewData[row]['rowData'][component]['data'][textFieldName] = textFieldValue;
        }
        this.setState({
            overviewData: overviewData
        })
    };


    returnTagStructure(tags) {
        let returnStructure = [];
        returnStructure.push({ id: "0", text: "notag" });
        Object.keys(tags).forEach(function (key) {
            returnStructure.push({
                id: key,
                text: key
            })
        });
        return returnStructure;
    }

    componentIsBeingEdited(status) {
        //console.log('status: ' + status);

    }

    render() {
        if (this.state.loading) {
            return <LoadingIndicator />;
        }


        let iodb = this.returnTagStructure(this.state.data.iotData.state.reported.iodb);
        let iotData = this.state.data.iotData.state.reported.iodb;
        let desiredIotData = get(this.state, 'data.iotData.state.desired.iodb', {});
        console.log(this.state)

        return (
            <div className="animated fadeIn overviewDeveloper">
                <NotificationHOC ref="notification" />
                <Row className="wide-overflow bg-sendInvites developer-toolbar">
                    <Col xs="10">
                        {this.state.developer && (
                            <ButtonToolbar>
                                <ButtonGroup className="mr-2">
                                    <Button color="light" onClick={() => this.addNew('row')}><i className="fa fa-bars"> </i></Button>
                                    <ButtonDropdown isOpen={this.state.dropdownOpen[0]} toggle={() => { this.toggle(0); }}>
                                        <DropdownToggle caret color="light">
                                            <i className="fa fa-plus"> </i>
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            <DropdownItem header>Add View</DropdownItem>
                                            <DropdownItem onClick={() => this.addNew('generator')}>Generator</DropdownItem>
                                            <DropdownItem onClick={() => this.addNew('ats')}>Ats</DropdownItem>
                                            <DropdownItem onClick={() => this.addNew('list')}>List</DropdownItem>
                                            <DropdownItem header>Add Control</DropdownItem>
                                            <DropdownItem onClick={() => this.addNew('controlToggle')}>Toggle</DropdownItem>
                                        </DropdownMenu>
                                    </ButtonDropdown>
                                </ButtonGroup>
                            </ButtonToolbar>
                        )}
                    </Col>
                    <Col xs="1">
                        {this.state.developer && (<Button block color="primary" onClick={() => this.saveConfiguration()}>Save</Button>)}
                    </Col>
                    <Col xs="1">
                        <Button block className={this.state.developer ? "btn-success" : "btn-developer"} onClick={() => this.toggleDeveloperMode()}>{this.state.developer ? "Play" : "Edit"}</Button>
                    </Col>
                </Row>
                <DeveloperOverviewRender developer={this.state.developer}
                    overviewdata={this.state.overViewData}
                    iodb={iodb}
                    tagBits={tagBits}
                    iotData={iotData}
                    desiredIotData={desiredIotData}
                    row={this.state.selectedRow}
                    dragtransfer={(rowDataItem, toRowNumber, fromRowNumber) => this.dragTransfer(rowDataItem, toRowNumber, fromRowNumber)}
                    deleterow={(rowId) => this.deleteItem('row', rowId)}
                    expandchildsize={(rowId, itemId) => this.expandChildSize(rowId, itemId)}
                    deletecomponent={(rowId, itemId) => this.deleteItem('component', rowId, itemId)}
                    selectedrow={(row) => this.setState({ selectedRow: row })}
                    savetextvaluechanges={(row, component, textFieldName, textFieldValue) => this.saveTextValueChanges(row, component, textFieldName, textFieldValue)}
                    addNewDataToChild={(schema, rowId, itemId, dataType) => this.addNewDataToChild(schema, rowId, itemId, dataType)}
                    componentIsBeingEdited={(status) => this.componentIsBeingEdited(status)}
                    writeControl={(tag, bit, state) => this.writeControl(tag, bit, state)}

                />

            </div>
        )
    }
}


export default Developer;



// WEBPACK FOOTER //
// ./src/views/site/Developer/DeveloperControl.js